import React from "react";

import useInView from "hooks/useInView";
import "./stats.scss";

const METRICS = [
  { value: "68", label: "Markets and counting" },
  { value: "131", label: "Data points per score" },
  { value: "MLS +", label: "Off-market deals" },
  { value: "Daily", label: "New deal alerts" },
];

const Stats = () => {
  const [ref, inView] = useInView();

  return (
    <section className="stats" id="data">
      <div ref={ref} className={`stats-inner ${inView ? "visible" : ""}`}>
        {METRICS.map((m) => (
          <div key={m.label} className="stat">
            <span className="stat-value">{m.value}</span>
            <span className="stat-label">{m.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
